import {
  GET_PLC_SAFETY_ZONE_DEPENDENCIES,
  GET_PLC_SAFETY_ZONE_DEPENDENCIES_SUCCESS,
  GET_PLC_SAFETY_ZONE_DEPENDENCIES_ERROR,
} from './actionTypes';

const initialState = {
  errorGetPlcSafetyZoneDependencies: '',
  loadingGetPlcSafetyZoneDependencies: false,
  zoneDependencies: null,
};

const getZoneDependencies = (state = initialState, action) => {
  switch (action.type) {
    case GET_PLC_SAFETY_ZONE_DEPENDENCIES:
      state = { ...state, loadingGetPlcSafetyZoneDependencies: true };
      break;
    case GET_PLC_SAFETY_ZONE_DEPENDENCIES_SUCCESS:
      state = { ...state, loadingGetPlcSafetyZoneDependencies: false, zoneDependencies: action.payload.zoneDependencies };
      break;
    case GET_PLC_SAFETY_ZONE_DEPENDENCIES_ERROR:
      state = { ...state, errorGetPlcSafetyZoneDependencies: action.payload, loadingGetPlcSafetyZoneDependencies: false };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default getZoneDependencies;
